import React from "react";
import {
    Route,
    Redirect,
} from "react-router-dom";
import {apiClient} from "../../services/ApiClient";

export default function PrivateRoute({ children, ...rest }) {
    return (
        <Route
            {...rest}
            render={({ location }) =>
                apiClient.isAuthenticated() ? (
                    children
                ) : (
                    <Redirect to={{pathname: "/login", state: { from: location } }} />
                )
            }
        />
    );
}